<div class="host">
    <img [src]="host.headshotURL" alt="Host Image" class="host__image">
    <div class="host__info">
        <h3 class="host__heading"><span class="host__name">{{ host.name }}</span><span *ngIf="host.title">,</span> <span class="host__title">{{ host.title }}</span></h3>
        <p class="host__description">{{ host.bio }}</p>
    </div>
</div>
